import React from 'react';
import { Layout, ConfigProvider, Spin } from 'antd';
import AppSiderBar from './AppSiderBar'
import {ErrorBoundary} from './ErrorBoundary';
import AppTopBar from './AppTopBar';
import AppFooterBar from './AppFooterBar'
import { Route, Routes } from "react-router-dom";
import { RecoilRoot } from "recoil";

// 懒加载路由组件 - 实现代码分割
const Dashboard = React.lazy(() => import(/* webpackChunkName: "dashboard" */ '../routes/Dashboard'));
const Accounts = React.lazy(() => import(/* webpackChunkName: "accounts" */ '../routes/Accounts'));
const Miners = React.lazy(() => import(/* webpackChunkName: "miners" */ '../routes/Miners'));
const AccountDetail = React.lazy(() => import(/* webpackChunkName: "account-detail" */ '../routes/AccountDetail'));
const MinerDetail = React.lazy(() => import(/* webpackChunkName: "miner-detail" */ '../routes/MinerDetail'));
const CspGallery = React.lazy(() => import(/* webpackChunkName: "csp-gallery" */ '../routes/CspGallery'));
const PlantDetail = React.lazy(() => import(/* webpackChunkName: "plant-detail" */ '../routes/PlantDetail'));
const StatGrowth = React.lazy(() => import(/* webpackChunkName: "stat-growth" */ '../routes/StatGrowth'));
const Page404 = React.lazy(() => import(/* webpackChunkName: "page-404" */ '../routes/Page404'));

// 页面加载占位组件
const PageLoading = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '50vh' 
  }}>
    <Spin size="large" />
  </div>
);

const { Content } = Layout;

function ExplorerBody(){
  return (
    <ConfigProvider 
    direction="ltr" 
    theme={{
        token: {
            fontFamily: 'Montserrat',
        },
    }}>
      <ErrorBoundary>
        <RecoilRoot>
          <Layout style={{height:'100vh'}}>
            <AppSiderBar/>
            <Layout>
              <Content style={{overflow:'auto'}}>
              <AppTopBar/>
                <div style={{minHeight: 'calc(100vh - 74px)',paddingBottom: '48px'}}>
                  <React.Suspense fallback={<PageLoading />}>
                    <Routes>
                      <Route path='/' element={<Dashboard />} />
                      <Route path='/dashboard' element={<Dashboard />} />
                      <Route path='/accounts' element={<Accounts />} />
                      <Route path='/account/:address' element={<AccountDetail />} />
                      <Route path='/miners' element={<Miners />} />
                      <Route path='/miner/:address' element={<MinerDetail />} />
                      <Route path='/plant/:address' element={<PlantDetail />} />
                      <Route path='/stat/:type' element={<StatGrowth />} />
                      <Route path='/404' element={<Page404 />} />
                      <Route path='/csp-gallery' element={<CspGallery />} />
                    </Routes>
                  </React.Suspense>
                </div>
                <AppFooterBar/>
              </Content>
            </Layout>
          </Layout>
        </RecoilRoot>
      </ErrorBoundary>
    </ConfigProvider>
    
  );
}

export default ExplorerBody;
